export const accountingConstants = {
  GET_COST_CENTERS: "GET_ACCOUNTING_COST_CENTERS",
  GET_LIST_ITEMS: "GET_ACCOUNTING_LIST_ITEMS",
  GET_LOCATIONS: "GET_ACCOUNTING_LOCATIONS",
  GET_NUMBERING_FLOWS: "GET_ACCOUNTING_NUMBERING_FLOWS",
  GET_EXPENSE_CATEGORIES: "GET_ACCOUNTING_EXPENSE_CATEGORIES",
  GET_TAX_CODES: "GET_ACCOUNTING_TAX_CODES",
};
